import { motion } from "framer-motion";
import { Headphones, BarChart3, Rocket } from "lucide-react";

const steps = [
  {
    icon: Headphones,
    step: "01",
    title: "Ascoltiamo",
    description: "Ci racconti chi sei, cosa fai e dove vuoi arrivare. Analizziamo la tua presenza digitale, i competitor e il tuo pubblico. Senza slide complicate: parliamo chiaro.",
  },
  {
    icon: BarChart3,
    step: "02",
    title: "Strategia su Misura",
    description: "Mettiamo nero su bianco un piano con obiettivi, tempi e priorità. L'intelligenza artificiale ci aiuta ad analizzare i dati e ottimizzare ogni decisione.",
  },
  {
    icon: Rocket,
    step: "03",
    title: "Azione e Risultati",
    description: "Attiviamo il team di professionisti giusto e iniziamo a lavorare operativamente. Monitoriamo i risultati e ottimizziamo costantemente le performance.",
  },
];

export default function ProcessSection() {
  return (
    <section id="metodo" data-testid="process-section" className="py-24 md:py-32" style={{ background: '#F8FAFC' }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-16">
          <p className="text-xs font-medium text-[#1B4332] uppercase tracking-wider mb-3">Il Nostro Metodo</p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight mb-4" style={{ fontFamily: 'Outfit', color: '#0F172A' }}>
            Come lavoriamo con te
          </h2>
          <p className="text-base md:text-lg text-slate-600 max-w-2xl mx-auto leading-relaxed">
            Un percorso semplice e strutturato: dall'ascolto all'azione, sempre con trasparenza e risultati misurabili.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((s, i) => (
            <motion.div
              key={s.step}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.5 }}
              className="relative bg-white rounded-2xl p-8 border border-slate-100 hover:shadow-lg transition-all duration-300 group"
              data-testid={`process-step-${i}`}
            >
              {/* Step number */}
              <span className="absolute top-6 right-6 text-6xl font-bold text-slate-100 select-none" style={{ fontFamily: 'Outfit' }}>
                {s.step}
              </span>

              <div className="w-14 h-14 rounded-xl bg-green-50 flex items-center justify-center mb-6 group-hover:bg-[#1B4332] transition-colors duration-300">
                <s.icon size={28} className="text-[#1B4332] group-hover:text-white transition-colors duration-300" />
              </div>

              <h3 className="text-xl font-semibold text-slate-900 mb-3" style={{ fontFamily: 'Outfit' }}>
                {s.title}
              </h3>
              <p className="text-slate-600 leading-relaxed text-sm">
                {s.description}
              </p>

              {/* Connector line for desktop */}
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 border-t-2 border-dashed border-slate-200" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
